// NPM
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import PDFGenerator from "html2pdf.js"
import { QRCodeSVG, QRCodeCanvas } from "qrcode.react"
import {isEmpty} from 'lodash'

// COMPONENTS
import {
    Button,
} from "@life-line-lab/components-react"

interface GenerateQRCodePDFProps {
    input: string[]
    className?: string
    selectedRows?: any;
}

/**
 * Renders a button. On click a PDF is downloaded for each of
 * the elements in the input array.
 * @param input - Array of strings to encode into QR codes.
 * @param className - A string to specify the button classes.
 */
const GenerateQRCodePDF: React.FC<GenerateQRCodePDFProps> = ({
    input,
    className,
    selectedRows,
}) => {
    const { t } = useTranslation()
    const [index, setIndex] = useState<any>(0)
    const [isLoading, setIsLoading] = useState(false)

    const handleGeneration = async () => {
        setIsLoading(true)

        for (let i = 0; i < input.length; i++) {
            // Copy the element to print
            const origin = document.getElementById('to-print')
            const element = origin?.cloneNode(true) as Element

            // Make the element visible
            element.removeAttribute("hidden")

            // Define PDF configuration
            var opt = {
                margin: 2,
                filename: `${input[i]}.pdf`,
                image: { type: 'png' },
                jsPDF: { orientation: 'p' },
            }

            // Generate the next QR code
            setIndex(i + 1)

            // Download PDF of current QR code
            await PDFGenerator().set(opt).from(element).save()
        }

        // Reset to initial
        setIndex(0)
        setIsLoading(false)
    }

    return (
        <React.Fragment>
            <Button
                className={className}
                label={t(`action.generateQRCode`)}
                type="primary"
                isDisabled={input?.length < 1}
                isLoading={isLoading}
                onClick={() => handleGeneration()}
            />
            <div id="to-print" hidden>
                <span className="center">
                    < QRCodeSVG
                        value={input[index]}
                        level="M"
                        size={250}
                    />
                </span>
                <span className="center">
                    {input[index]}
                </span>
            </div>
        </React.Fragment>
    )
}

export default GenerateQRCodePDF